import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { CardSkeleton, Pagination, Typography } from '@/components/atoms';
import { GridList } from '@/components/molecules';
import { IPagination } from '@/interfaces/index';
import { useTranslation } from 'next-i18next';
interface ICardGridPagination {
  template?: string;
  itemsArray: JSX.Element[] | null;
  pagination: IPagination | null;
  onPageChange?: (pageNumber: number) => void;
  isLoading?: boolean;
  max: number;
}

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const GridListWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;
const NoProductsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  margin-bottom: 16px;
`;

const CardGridPagination: React.FC<ICardGridPagination> = ({
  template,
  itemsArray,
  pagination,
  onPageChange,
  isLoading,
  max,
}) => {
  let skeletons = [];
  const { t } = useTranslation('product');

  const skeletonsNeed = isLoading;
  if (skeletonsNeed) {
    for (let i = 0; i < max; i++) {
      skeletons.push(
        <CardSkeleton key={`dummycard-${i}`} template={template}></CardSkeleton>
      );
    }
  }

  const paginationChange = (_event: ChangeEvent<unknown>, page: number) => {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  return (
    <>
      {skeletonsNeed ? (
        <GridList template={template}>{skeletons}</GridList>
      ) : itemsArray && itemsArray.length > 0 ? (
        <>
          <GridListWrapper>
            <GridList template={template}>{itemsArray}</GridList>
          </GridListWrapper>
          {pagination && (
            <>
              <PaginationWrapper>
                <Pagination
                  page={pagination.active}
                  count={pagination.totalPages}
                  onChange={paginationChange}
                />
              </PaginationWrapper>
            </>
          )}
        </>
      ) : (
        <NoProductsWrapper>
          <Typography component="p" datatype="body_1">
            {t('product:no-product-found')}
          </Typography>
        </NoProductsWrapper>
      )}
    </>
  );
};

export default CardGridPagination;
